var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){_vm.num++}}},[_vm._v(" 我是全局组件"+_vm._s(_vm.num)+" ")]),_c('button',{on:{"click":_vm.ck}},[_vm._v("传送")])])
}
var staticRenderFns = []

export { render, staticRenderFns }